import { BlackBrandButton } from "@components/ui/button";
import { Color } from "@styles/constants";
import styled from "styled-components";

export const TransferDataRow = styled.section`
  display: flex;
`;

export const DataColumn = styled.div`
  width: 50%;
`;

export const DetailContainer = styled.section`
  margin: 30px 0px 30px 0px;
  padding: 30px 0px 30px 0px;
  border: solid ${Color.grayLight3};
  border-width: 1px 0px 1px 0px;
`;

export const Button = styled.button`
  ${BlackBrandButton}
`;

export const Form = styled.form`
  display: flex;
  justify-content: center;
`;
